<svg viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect x="1" y="1" width="26" height="26" rx="8" stroke="#2C4F26" stroke-width="2" fill="#D5DCD4"/>
  <path
    d="M11 15.5L13 17.5L17.5 10"
    pathLength="1"
    stroke="#2C4F26"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
